import { render, staticRenderFns } from "./Clickable.vue?vue&type=template&id=50bdad52&"
import script from "./Clickable.vue?vue&type=script&lang=js&"
export * from "./Clickable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports